/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationscontentfulContentfulIntegration1 from './IntegrationscontentfulContentfulIntegration1';

/**
 * The IntegrationsContentfulBody1 model module.
 * @module model/IntegrationsContentfulBody1
 * @version v0.3
 */
export default class IntegrationsContentfulBody1 {
  /**
   * Constructs a new <code>IntegrationsContentfulBody1</code>.
   * @alias module:model/IntegrationsContentfulBody1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsContentfulBody1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsContentfulBody1} obj Optional instance to populate.
   * @return {module:model/IntegrationsContentfulBody1} The populated <code>IntegrationsContentfulBody1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsContentfulBody1();
      if (data.hasOwnProperty('contentful_integration'))
        obj.contentfulIntegration = IntegrationscontentfulContentfulIntegration1.constructFromObject(data['contentful_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationscontentfulContentfulIntegration1} contentfulIntegration
 */
IntegrationsContentfulBody1.prototype.contentfulIntegration = undefined;

